<div class="page-section series-form-page">
	<div class="app-l-page__navigation">
		<div class="app-l-page__previous" (click)="onClose()">
			<button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
				<svg-icon icon="arrow-left" class="w-100 h-100"></svg-icon>
			</button>
		</div>
		<div class="app-l-page__breadcrumbs">
			<ul class="breadcrumbs-list">
				<li class="breadcrumbs-list-item">
					<a [routerLink]="['/admin/organization-listing']">Organizations</a>
				</li>
				<li class="breadcrumbs-list-item">
					<a [routerLink]="['/admin/organization', orgId]">Organization</a>
				</li>
				<li class="breadcrumbs-list-item app-l-current-page">
					Create Access Code
				</li>
			</ul>
		</div>
	</div>
	<div class="page-section-content">
		<div class="form-wrapper-80">
			<p>Create an access code by typing a string in the box below.</p>

			<div class="app-c-form-group">
				<label class="app-c-form--label" for="accesscode">Access Code</label>
				<input
					class="app-c-form-control"
					type="text"
					[(ngModel)]="accesscode"
					id="accesscode" />
				<div class="error-message"
					*ngIf="submitButtonPressed && !accesscode">
					Please type in an access code.
				</div>
			</div>

			<div class="fixed-footer">
				<div class="validation-banner" *ngIf="errors">
					{{ errors }}
				</div>
				<button class="app-c-btn app-c-btn--primary app-c-btn--curve" (click)="doSave()">
					Save
				</button>
			</div>
		</div>
	</div>
</div>
